import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CheckoutSteps from '../Components/CheckoutSteps'
import { Link } from 'react-router-dom';
import flag_india from '../Media/flag_india.png'
import paytmLogo from '../Media/paytm.png';
import phonepeLogo from '../Media/phonepe.svg';
import razorpayLogo from '../Media/razorpay.svg';
import { createOrder } from '../Actions/orderActions';
import { ORDER_CREATE_RESET } from '../Constants/orderConstants';
import './PlaceOrderScreen.css';

export default function PlaceOrderScreen(props) {
    const cart = useSelector(state => state.cart);
    const [checkoutMeta, setCheckoutMeta] = useState(null);
    const [checkoutSingle, setCheckoutSingle] = useState(null);

    // Load variant/meta info saved during Delivery step
    useEffect(() => {
        try {
            const meta = localStorage.getItem('checkoutMeta');
            setCheckoutMeta(meta ? JSON.parse(meta) : null);
        } catch (_) { setCheckoutMeta(null); }
        try {
            const single = localStorage.getItem('checkoutItem');
            setCheckoutSingle(single ? JSON.parse(single) : null);
        } catch (_) { setCheckoutSingle(null); }
    }, []);

    if(!cart.paymentMethod){
        props.history.push('/payment')
    }

    const toPrice = (num) => Number(num.toFixed(2));  // 5.123 => "5.12" => 5.12
    // Only include the product coming from Delivery screen
    const filteredItems = useMemo(() => {
        const pid = checkoutSingle?.productId;
        if (!pid) return cart.cartItems || [];
        return (cart.cartItems || []).filter(ci => ci.product === pid);
    }, [cart.cartItems, checkoutSingle]);

    // If checkout storage has a qty for this product, prefer it (guards against any stale cart write)
    const adjustedItems = useMemo(() => {
        const q = Number(checkoutSingle?.qty);
        if (!Number.isFinite(q) || q <= 0) return filteredItems;
        return filteredItems.map(it => (
            checkoutSingle?.productId === it.product
                ? { ...it, qty: q }
                : it
        ));
    }, [filteredItems, checkoutSingle]);

    const itemCount = adjustedItems.reduce((a,c) => a + Number(c.qty || 0), 0);
    cart.itemPrice = toPrice(adjustedItems.reduce((a,c) => a + c.product_price * c.qty, 0));

    cart.shippingCharges = toPrice(0);

    //  cart.taxPrice = toPrice(0.15 * cart.itemPrice);
    //  cart.totalPrice = cart.itemPrice + cart.shippingCharges + cart.taxPrice; 
    
    cart.totalPrice = cart.itemPrice + cart.shippingCharges; 

    const dispatch = useDispatch();
    const placingRef = useRef(false);

    const orderCreate = useSelector((state) => state.orderCreate);
    const { success: orderSuccess, orderId, error: orderError, loading: orderLoading, paymentMethod: createdPaymentMethod, productTitle } = orderCreate || {};

    // Reset any stale previous order success when entering Place Order
    useEffect(() => {
        try { dispatch({ type: ORDER_CREATE_RESET }); } catch (_) {}
    }, []);

    useEffect(() => {
        if (placingRef.current && orderSuccess && orderId) {
            const rawPm = createdPaymentMethod || cart.paymentMethod || '';
            const pmUpper = String(rawPm).toUpperCase();
            // Debug: trace the method used to decide navigation
            try { console.log('[PlaceOrder] Redirect decision:', { createdPaymentMethod, cartPm: cart.paymentMethod, pmUpper, orderId }); } catch (_) {}
            if (pmUpper === 'COD') {
                props.history.replace('/order-success', { orderId, productTitle });
            } else {
                props.history.push(`/payment/${orderId}`);
            }
        }
    }, [orderSuccess, orderId, createdPaymentMethod, productTitle, cart.paymentMethod, props.history]);

    const placeOrderHandler = () => {
        placingRef.current = true;
        // Attach selected size/color to the item being ordered
        const orderItems = adjustedItems.map((it) => {
            if (checkoutSingle?.productId === it.product) {
                return {
                    ...it,
                    selected_size: checkoutMeta?.size || null,
                    selected_color: checkoutMeta?.color || null,
                    line_total: Number(it.qty) * Number(it.product_price),
                };
            }
            return {
                ...it,
                line_total: Number(it.qty) * Number(it.product_price),
            };
        });
        dispatch(createOrder({
            ...cart,
            orderItems
        }));
    }

    // Reset session flag on unmount
    useEffect(() => {
        return () => { placingRef.current = false; };
    }, []);
    return (
        <div>
            <CheckoutSteps step1 step2 step3 step4></CheckoutSteps>
            <div className="row top">
                <div className="col-2">
                    <ul>
                        <li>
                            <div className="card card-body">
                                <h2>Order Items</h2>
                                <ul>
                                    {
                                        adjustedItems.map((item)=>(
                                        <li key={item.product}>
                                            <div className="row">
                                                <div>
                                                    <img
                                                        src={item.product_image_1}
                                                        alt={item.product_title}
                                                        className="small"
                                                    ></img>
                                                </div>
                                                <div className="min-30">
                                                    <Link to={`/product/${item.product}`}>{item.product_title}</Link>
                                                    {checkoutSingle?.productId === item.product && (
                                                        <div style={{ fontSize: '0.9rem', color: '#374151', marginTop: 4 }}>
                                                            <span>Size: <strong>{checkoutMeta?.size || 'Not Available'}</strong></span>
                                                            {' · '}
                                                            <span>Color: <strong>{checkoutMeta?.color || 'Not Available'}</strong></span>
                                                        </div>
                                                    )}
                                                </div>
                                              
                                                <div>
                                                    {item.qty} x ₹ {item.product_price}/-
                                                     =  ₹ {item.qty*item.product_price}/-
                                                </div>
                                                
                                                
                                            </div>
                                        </li>
                                    ))
                                    }
                                </ul>
                            </div>
                        </li>

                        <li>
                            <div className="card card-body">
                                <h2>Payment Method</h2>
                                <div className="payment-method-display">
                                    {(() => {
                                        const method = cart.paymentMethod;
                                        let label = method;
                                        let logo = null;
                                        let fallback = 'PAY';

                                        if (method === 'PAYTM') {
                                            label = 'Paytm';
                                            logo = paytmLogo;
                                            fallback = 'PT';
                                        } else if (['PHONEPE','PHONEPAY'].includes(method)) {
                                            label = 'PhonePe';
                                            logo = phonepeLogo;
                                            fallback = 'PP';
                                        } else if (['RAZORPAY','RAZERPAY'].includes(method)) {
                                            label = 'Razorpay';
                                            logo = razorpayLogo;
                                            fallback = 'RZ';
                                        } else if (method === 'COD') {
                                            label = 'Cash on Delivery';
                                            fallback = 'COD';
                                        } 

                                        return (
                                            <div className="payment-method-row">
                                                {logo ? (
                                                    <img src={logo} alt={label} className="payment-logo" />
                                                ) : (
                                                    <div className="payment-fallback">{fallback}</div>
                                                )}
                                                <span className="payment-label">{label}</span>
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                        </li>

                        <li>
                            <div className="card card-body">
                                <h2>Shipping Address <img className='flag_india_small' src={flag_india} alt="flag" /></h2>
                                <p>
                                    <strong>Name:</strong> {cart.shippingAddress.name}<br/>
                                    <strong>Address:</strong> {cart.shippingAddress.landmark},{' '}
                                    {cart.shippingAddress.flatNo},{' '}
                                    {cart.shippingAddress.locality},{' '}
                                    {cart.shippingAddress.city},{' '}
                                    {cart.shippingAddress.state}-
                                    {cart.shippingAddress.pinCode}.<br/>
                                    <strong>Mobile:</strong> +91-{cart.shippingAddress.mobileNo}
                                    {cart.shippingAddress.alternateMobileNo ? `, ${cart.shippingAddress.alternateMobileNo}` : ''}
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="col-1">
                    <div className="card card-body">
                        <ul>
                            <li>
                                <h2>Order Summary</h2>
                            </li>
                            <li>
                                <div className="row">
                                    <div>Subtotal {itemCount > 0 ? `(${itemCount} item${itemCount>1?'s':''})` : ''}</div>
                                    <div>₹ {cart.itemPrice.toFixed(2)}/-</div>
                                </div>
                            </li>
                            <li>
                                <div className="row"> 
                                    <div>Shipping Charges</div>
                                    <div>₹ {cart.shippingCharges.toFixed(2)}/-</div>
                                </div>
                            </li>
                            {/* <li>
                                <div className="row">
                                    <div>Tax</div>
                                    <div>₹ {cart.taxPrice.toFixed(2)}/-</div>
                                </div>
                            </li> */}
                            <li>
                                <div className="row">
                                    <div><strong>Order Total</strong></div>
                                    <div><strong>₹ {cart.totalPrice.toFixed(2)}/-</strong></div>
                                </div>
                            </li>
                            <li>
                                <button type="button"
                                        onClick={placeOrderHandler}
                                        className="primary block"
                                        disabled={cart.cartItems.length === 0 || orderLoading}
                                >
                                    {orderLoading ? 'Placing…' : 'Place Order'}
                                </button>
                                {orderError && (
                                    <div style={{ marginTop: 8, color: '#b91c1c' }}>{orderError}</div>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
  